<div class="talking-to">
  <button type="button" class="talking-to__trigger" [attr.aria-expanded]="isOpen" [attr.aria-label]="caption + ': ' + (selectedTarget?.label || '')" (click)="toggle()">
    <span class="talking-to__mark" [class.talking-to__mark--deo]="isDeoSelected" aria-hidden="true">
      <img *ngIf="isDeoSelected" [src]="deoIcon" alt="" width="24" height="24" />
      <ng-container *ngIf="!isDeoSelected">{{ selectedTarget?.mark }}</ng-container>
    </span>
    <span class="talking-to__body">
      <span class="talking-to__caption">{{ caption }}</span>
      <span class="talking-to__current">
        <span class="talking-to__name">{{ selectedTarget?.label }}</span>
        <svg-icon src="assets/icons/arrow-down.svg" class="talking-to__chevron" aria-hidden="true"></svg-icon>
      </span>
    </span>
  </button>

  <div class="talking-to__panel" *ngIf="isOpen" role="listbox" [attr.aria-label]="caption">
    <ng-container *ngFor="let target of targets; trackBy: trackById">
      <!-- DEO is not an agent: no AgentDefinition to give the card, and its own mark colours. -->
      <div class="talking-to__row" *ngIf="isDeo(target)" [class.talking-to__row--current]="isCurrent(target)" role="option" [attr.aria-selected]="isCurrent(target)">
        <button type="button" class="talking-to__deo" (click)="select(target)">
          <span class="talking-to__mark talking-to__mark--deo" aria-hidden="true">
            <img [src]="deoIcon" alt="" width="24" height="24" />
          </span>
          <span class="talking-to__deo-name">{{ target.label }}</span>
        </button>
        <svg-icon src="assets/icons/check.svg" class="talking-to__check" *ngIf="isCurrent(target)" aria-hidden="true"></svg-icon>
      </div>

      <div class="talking-to__row" *ngIf="!isDeo(target)" [class.talking-to__row--current]="isCurrent(target)" role="option" [attr.aria-selected]="isCurrent(target)">
        <gains-agent-card class="talking-to__agent" [agent]="target.agent" variant="compact" (opened$)="select(target)"></gains-agent-card>
        <svg-icon src="assets/icons/check.svg" class="talking-to__check" *ngIf="isCurrent(target)" aria-hidden="true"></svg-icon>
      </div>
    </ng-container>
  </div>
</div>
